import React from "react";
import clsx from 'clsx';
import { SvgIcon } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const blockStyles = makeStyles(theme => ({
  root: {
    width: 24,
    height: 24,
    fill: "transparent"
  }
}));

const IcRedBadge = (props) => {

  const classes = blockStyles();
  const { className } = props;

  return (
    <SvgIcon className = { clsx(classes.root, className) }
             viewBox = { "0 0 24 24" } >
      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z" fill="#F2685F"/>
      <path d="M11 15H13V17H11V15ZM11 7H13V13H11V7Z" fill="white"/>
    </SvgIcon>
  );
}

export default IcRedBadge;
